export const KYOTEN_ID_ONLINE_KAKYO = 120;
export const SHIHARAI_KBN_ID_CREDIT_CARD = 5;
export const SHIHARAI_KBN_ID_CREDIT_NAME = 'クレジット';
export const STUDENT_ITAKU_KBN_ID_US = 4;